module.exports = __webpack_public_path__ + "static/asp-net-03a55433f6900d6fb3f35e873df768bd.png";